import ZoneCard from './ZoneCard';

export default ZoneCard;
